/**
 * Semantic rule for GraphElement: `selected = true` authored with
 * `selectable = false`. Error tier (ADR-0032): `set_selectable(false)` calls
 * `set_selected(false)` before it stores the flag (`scene/gui/graph_element.cpp`),
 * and `set_selected` returns early once `is_selectable()` is false.
 */
import { ruleRegistry } from '../../../../linter/RuleRegistry.js';
import { armDiagnostic, armEmits } from '../../../../linter/ruleArms.js';
import { descendsFromClass } from '../../../../godot/classdb/classBaseTypes.js';
import { boolSlotValue } from '../../../../godot/variant/variantBool.js';
const arms = {
    selectedNotSelectable: {
        severity: 'error',
        ruleName: 'graph-element-selected-not-selectable',
        grounding: { kind: 'engine', at: 'graph_element.cpp:207' },
    },
};
// Either load order ends unselected: `selectable` first makes the later
// `selected = true` a no-op, and `selected` first is undone by the
// `set_selected(false)` that `set_selectable(false)` runs while `is_selectable()`
// still reads true. The .tscn keeps showing `selected = true`.
function checkSelectedRequiresSelectable(context) {
    const { node } = context;
    const props = node.rawProperties;
    const selectableRaw = props.selectable;
    const selectedRaw = props.selected;
    if (selectableRaw === undefined || selectedRaw === undefined)
        return [];
    if (boolSlotValue(selectableRaw) !== false || boolSlotValue(selectedRaw) !== true)
        return [];
    return [
        armDiagnostic(arms.selectedNotSelectable, node, "GraphElement has 'selected = true' alongside 'selectable = false'. Godot's " +
            'GraphElement::set_selectable forces set_selected(false) whenever selectable ' +
            'becomes false, regardless of load order, so this element always loads ' +
            'deselected — the authored selected value never takes effect.'),
    ];
}
const selectedRequiresSelectableRule = {
    meta: {
        name: 'valid-graph-element-selection',
        description: 'Flags a GraphElement authored with selected = true and selectable = false — Godot ' +
            'always forces the element back to deselected regardless of load order',
        category: 'validation',
        applicableNodeTypeMatcher: (nodeType) => descendsFromClass(nodeType, 'GraphElement'),
        emits: armEmits(arms),
    },
    check: checkSelectedRequiresSelectable,
};
ruleRegistry.register(selectedRequiresSelectableRule);
//# sourceMappingURL=linter.js.map